import { put, takeLatest } from "redux-saga/effects";
import { translation } from "Helpers/i8n-helper";
import {
    getRedeemings,
    getRedeemingsError,
    getRedeemingsSuccess,
    redeem,
    redeemError,
    redeemSuccess
} from "../reducers/redeem-reducer";
import { getAllRedeemings, createRedeem, createRedeemViaPaypal } from "../../services/redeem";
import { updateUser } from "../reducers/AuthReducer";
import { message } from "antd";

const t = translation("error");

function* GetRedeems() {
    try {
        const response = yield getAllRedeemings();
        if (response?.success) {
            yield put(getRedeemingsSuccess(response.redeemings));
        } else {
            yield put(getRedeemingsError(t("errorOccurred")));
        }
    } catch (e) {
        console.log("Error fetching redeemings", e);
        yield put(getRedeemingsError(t("errorOccurred")));
    }
}

function* Redeem({ payload }) {
    try {
        let response = undefined;

        if (payload.viaPaypal) {
            response = yield createRedeemViaPaypal(payload);
        } else {
            response = yield createRedeem(payload);
        }

        if (response?.success) {
            yield put(redeemSuccess(response));
            yield put(updateUser(response.user));
            message.success(payload.viaPaypal ? `Cash sent via Paypal successfully to ${payload.user.email}` : "Cash sent to wallet successfully");
        } else {
            yield put(redeemError(response.message || t("errorOccurred")));
            message.error(response.message || t("errorOccurred"));
        }
    } catch (e) {
        console.log("Error while redeeming", e);
        yield put(redeemError(e));
    }
}

// function* RedeemViaPaypal({ payload }) {
//     try {
//         console.log("REDEEM VIA PAYPAL")
//         const response = yield createRedeemViaPaypal(payload);

//         console.log("response redeem", response);
//         if (response?.success) {
//             yield put(redeemSuccess(response));
//             yield put(updateUser(response.user));
//         } else {
//             yield put(redeemError(response.message || t("errorOccurred")));
//             message.error(response.message || t("errorOccurred"));
//         }
//     } catch (e) {
//         console.log("Error adding organization", e);
//         yield put(redeemError(e));
//     }
// }

function* RedeemSaga() {
    yield takeLatest(getRedeemings.type, GetRedeems);
    yield takeLatest(redeem.type, Redeem);
}

export default RedeemSaga;
